import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitTopLeft20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconArrowFitTopLeft20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.749 2A2.75 2.75 0 0 0 2 4.75v8.5a.75.75 0 0 0 1.5 0v-8.5q0-.09.012-.177L15.441 16.5H10.25a.75.75 0 1 0 0 1.5H18v-7.75h-.75.75a.75.75 0 0 0-1.5 0h.75-.75v5.188L4.573 3.512A1 1 0 0 1 4.75 3.5h8.501a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitTopLeft20);
